import { FC, ReactNode } from "react";

export type FormSectionProps = {
  title: string;
  icon?: ReactNode;
  children: ReactNode;
};

export const FormSection: FC<FormSectionProps> = ({
  title,
  icon,
  children,
}) => {
  return (
    <section className="w-full">
      <header className="border-b-px flex w-full items-center gap-2 border border-x-0 border-t-0 border-solid border-gray-200 px-px pb-2">
        {icon && <div className="flex shrink-0 items-center">{icon}</div>}
        <div
          id="form-section-title"
          className="font-secondary grow truncate text-base font-medium text-[#383838]"
          title={title}
        >
          {title}
        </div>
      </header>
      <div className="py-4">{children}</div>
    </section>
  );
};
